export class OptimizationStrategyApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getStrategies() {
    return this.#http.get('/api/optimization-strategies');
  }

  async getStrategy({ strategyId }) {
    return this.#http.get(`/api/optimization-strategies/${strategyId}`);
  }

  async createStrategy(body) {
    return this.#http.post('/api/optimization-strategies', body);
  }

  async updateStrategy({ id, ...body }) {
    return this.#http.put(`/api/optimization-strategies/${id}`, body);
  }

  async deleteStrategy({ strategyId }) {
    return this.#http.delete(`/api/optimization-strategies/${strategyId}`);
  }

  async getStrategyVersions({ strategyId }) {
    return this.#http.get(`/api/optimization-strategies/${strategyId}/versions`);
  }

  async setActiveStrategy({ strategyId }) {
    return this.#http.post(`/api/optimization-strategies/${strategyId}/activate`);
  }
}
